module.exports = __webpack_public_path__ + "static/media/products-alt-2.e82a71eb.jpg";